import {
  Component,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { headerSetting } from 'src/_lib/interfaces/homepagesettings.interface';
import { HeaderService } from 'src/_lib/service/header.service';
import { HeadersDataInterface } from 'src/_lib/interfaces/header.interface';
import { AppConstants } from 'src/app/app.constants';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { HeaderCh1Component } from './header-ch1/header-ch1.component';
import { HeaderCh2Component } from './header-ch2/header-ch2.component';
import { HeaderCh3Component } from './header-ch3/header-ch3.component';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { HeaderCh5Component } from './header-ch5/header-ch5.component';
import { HeaderCh4Component } from './header-ch4/header-ch4.component';
import { HeaderCh6Component } from './header-ch6/header-ch6.component';
import { HeaderCh7Component } from './header-ch7/header-ch7.component';
import { HeaderCh9Component } from './header-ch9/header-ch9.component';
import { HeaderCh8Component } from './header-ch8/header-ch8.component';
import { HeaderCh10Component } from './header-ch10/header-ch10.component';
import { HeaderCh11Component } from './header-ch11/header-ch11.component';
import { BrowserService } from 'src/_lib/service/browser.service';
import { HeaderCh12Component } from './header-ch12/header-ch12.component';
import { HeaderCh13Component } from './header-ch13/header-ch13.component';
import { HeaderCh14Component } from './header-ch14/header-ch14.component';
import { HeaderCh16Component } from './header-ch16/header-ch16.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    HeaderCh1Component,
    HeaderCh2Component,
    HeaderCh3Component,
    HeaderCh4Component,
    HeaderCh5Component,
    HeaderCh6Component,
    HeaderCh7Component,
    HeaderCh8Component,
    HeaderCh9Component,
    HeaderCh10Component,
    HeaderCh11Component,
    HeaderCh12Component,
    HeaderCh13Component,
    HeaderCh14Component,
    HeaderCh16Component
  ],
    encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  imgBasePath: string = environment.imageBasePath;
  isMobile: boolean = false;
  showSearchBar: boolean = false;
  showFirstRowHeader: boolean = null;
  showSecondRowHeader: boolean = null;
  showLogo: boolean = null;
  showMyAccount: boolean = null;
  showWebsiteHeader: boolean = null;
  showThirdRowHeader: boolean = null;
  firstObj: number = this.appConstants.firstObj;
  showFlag: boolean = null;
  headerdata: HeadersDataInterface = {
    websiteHeader: [],
    firstRow: [],
    secondRow: [],
    thirdRow: [],
  };
  vehicleBtnFlag = {
    do_not_show: false,
    header_link: false,
    homepage_slider: false,
    homepage_slider_header: false,
    vehicle_search_all_pages: false,
    header_sidebar:false
  }
  custom_ticker: any;
  isSticky = false;
  isSidebarOpen = false;
  cdnImagePath: string = environment.cdnImagePath;
  showCart = false;
  showdowntooltip: boolean = true;
  isWishlist: boolean = false;
  chTheme1 = environment.chTheme1;
  chTheme2 = environment.chTheme2;
  chTheme3 = environment.chTheme3;
  chTheme4 = environment.chTheme4;
  chTheme5 = environment.chTheme5;
  chTheme6 = environment.chTheme6;
  chTheme7 = environment.chTheme7;
  chTheme8 = environment.chTheme8;
  chTheme9 = environment.chTheme9;
  chTheme10 = environment.chTheme10;
  chTheme11 = environment.chTheme11;
  chTheme12 = environment.chTheme12;
  chTheme13 = environment.chTheme13;
  chTheme14 = environment.chTheme14;
  chTheme15 = environment.chTheme15;
  chTheme16 = environment.chTheme16;
    isSearchByVehicleDisabled: boolean = false;
  eventHandler = () => this.showCart = true;
  @Input() headerSettings: headerSetting<string> = null;

  constructor(
    private headerHttp: HeaderService,
    private appConstants: AppConstants,
    private comm: CommunicationService,
    private commanService: CommanpageService,
    private browser: BrowserService
  ) {
    // FLASH FIX: Read ticker from localStorage in the constructor — before the
    // first render cycle — so the promotion bar is visible from frame 1.
    // ngOnInit fires after the first render, which is too late and causes flash.
    if (this.browser.isBrowser) {
      const cachedTicker = this.headerHttp.getStoredTickerData();
      if (cachedTicker) {
        this.custom_ticker = cachedTicker[0]?.data;
      }
    }
  }

  ngOnInit(): void {
    this.headerFlag();

    // CRITICAL OPTIMIZATION: Don't block initial render
    // Defer all non-critical header data loading
    if (this.browser.isBrowser) {
      // Load header data after initial render (non-blocking)
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(() => {
          this.loadHeaderDataDeferred();
        }, { timeout: 1000 });
      } else {
        setTimeout(() => this.loadHeaderDataDeferred(), 200);
      }
    }
    
    this.comm.showVehicleButton.subscribe(() => {
      const vehicleBtnData = this.commanService.isSearchByVehicleDisabled();
      this.isSearchByVehicleDisabled = vehicleBtnData?.header_link;
    });
    this.comm.cacheClear.subscribe(()=>{
      this.getheaderList();
      this.getPromotionData();
      this.getWishItems()
    })
    this.browser.runInBrowser(() => {
      this.browser.window?.addEventListener('open-shopping-cart', this.eventHandler);
    });
    this.browser.runInBrowser(() => {
      this.checkScreenSize();
    });
    
  }

  /**
   * CRITICAL OPTIMIZATION: Load header data in background after initial render
   * This prevents blocking the initial page load
   */
  private loadHeaderDataDeferred(): void {
    // Only load if not already loaded
    if (!this.headerdata?.websiteHeader?.length) {
      this.getheaderList();
    }
    if (!this.custom_ticker) {
      this.getPromotionData();
    }
  }

  @HostListener('window:resize', [])
  onResize(): void {
    this.browser.runInBrowser(() => {
      this.checkScreenSize();
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isSticky = (this.browser.window?.scrollY ?? 0) > 170;
  }

  getWishItems(): void {
    // Only run in browser — localStorage is unavailable on SSR and isWishlist
    // drives [ngClass] bindings that must match between SSR and client.
    if (!this.browser.isBrowser) return;
    const wishItems = +(this.browser.localStorage?.getItem('wishlistItem') || 0);
    this.isWishlist = wishItems > 0;
    this.comm.wishlistCount.subscribe(() => {
      const wishItems = +(this.browser.localStorage?.getItem('wishlistItem') || 0);
      this.isWishlist = wishItems > 0;
    });
  }

  getheaderList(): void {
    this.headerHttp.headerList().subscribe((data) => {
      this.headerdata = data[this.firstObj].data;
    });
  }

  checkScreenSize(): void {
    if ((this.browser.window?.innerWidth ?? 0) > 768) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  }

  onSearchBarEvent(event: boolean) {
    this.showSearchBar = event;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerSettings']?.currentValue) {
      this.headerSettings = changes['headerSettings']?.currentValue;
      this.showFirstRowHeader = this.headerSettings.first_row_header === 'true';
      this.showSecondRowHeader = this.headerSettings.second_row_header === 'true';
      this.showThirdRowHeader = this.headerSettings.third_row_header === 'true';
      this.showLogo = this.headerSettings.logo === 'true';
      this.showMyAccount = this.headerSettings.my_account === 'true';
      this.showFlag = this.headerSettings.made_in_usa_flag === 'true';
    }
  }

  getPromotionData() {
    this.headerHttp.getTickersData().subscribe((data) => {
      this.custom_ticker = data[this.firstObj].data;
    });
  }

  onImageError(event: any) {
    event.target.src = `${this.imgBasePath}/footer_logo.webp`;
  }

  scrollTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


headerFlag() {
   if(!this.chTheme1 && !this.chTheme2 && !this.chTheme3 && !this.chTheme4 && !this.chTheme5 && !this.chTheme6 && !this.chTheme7 && !this.chTheme8 && !this.chTheme9 && !this.chTheme10 && !this.chTheme11 && !this.chTheme12 && !this.chTheme13 && !this.chTheme14 && !this.chTheme15 && !this.chTheme16 ){
   this.chTheme1=true } }

  ngOnDestroy() {
    this.browser.window?.removeEventListener('open-shopping-cart', this.eventHandler);
  }
}